var ve = Object.defineProperty;
var ze = (e, n, r) => n in e ? ve(e, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[n] = r;
var Y = (e, n, r) => (ze(e, typeof n != "symbol" ? n + "" : n, r), r);
import { utils as c, BaseDocument as G, applyMixins as Ge, actions as Ie } from "document-model/document";
import { z as t } from "./account-snapshot.js";
const Me = {
  id: "arbitrum/ltip-grantee",
  name: "Arbitrum LTIP Grantee",
  extension: "grantee",
  description: "Arbitrum ltip grantee",
  author: {
    name: "Goldenmule Media",
    website: "https://thegoldenmule.com"
  },
  specifications: [
    {
      version: 1,
      changeLog: [],
      state: {
        global: {
          schema: `scalar DateTime

type ArbitrumLtipGranteeState {
  id: ID!
  granteeName: String
  authorizedSignerAddress: String
  editorAddresses: [String]
  grantSize: Float
  matchingGrantSize: Float
  grantSummary: String
  fundingAddress: String
  fundingType: [FundingType]
  disbursementContractAddress: String
  metricsDashboardLink: String
  phases: [Phase]
  meta: [Meta]
}

enum FundingType {
  EOA
  Multisig
  TwoofThreeMultisig
  ThreeofFiveMultisig
}

type Phase {
  startDate: DateTime!
  endDate: DateTime!
  actuals: GranteeActuals
  planned: GranteePlanned
  stats: GranteeStats
  status: Status
}

enum Status {
  Uninitialized
  NotStarted
  InProgress
  Finalized
}

type GranteeActuals {
  arbReceived: Float
  arbUtilized: Float
  arbRemaining: Float
  contractsIncentivized: [Contract]
  incentives: String
  summary: String
  disclosures: String
}

type GranteePlanned {
  arbToBeDistributed: Float
  contractsIncentivized: [Contract]
  distributionMechanism: [DistributionMechanism]
  changes: String
  expectations: String
}

type GranteeStats {
  avgDailyTVL: Float
  avgDailyTXNS: Float
  avgDailyUniqueUsers: Float
  kpis: [NamedKpi]
  changes: String
  lessons: String
}

type NamedKpi {
  name: String
  value: Float
}

type Contract {
  contractId: ID!
  contractLabel: String
  contractAddress: String
}

enum DistributionMechanism {
  LPIncentives
  Airdrop
}

type Meta {
  protocolVersion: String!
  isAdmin: Boolean
  value: String
}

`,
          initialValue: '"{\\"id\\":\\"\\",\\"granteeName\\":\\"\\",\\"authorizedSignerAddress\\":\\"\\",\\"editorAddresses\\":[],\\"grantSize\\":0,\\"matchingGrantSize\\":0,\\"grantSummary\\":\\"\\",\\"fundingAddress\\":\\"\\",\\"fundingType\\":[],\\"disbursementContractAddress\\":\\"\\",\\"metricsDashboardLink\\":\\"\\",\\"phases\\":[],\\"meta\\":[]}"',
          examples: []
        },
        local: {
          schema: "type ArbitrumLtipGranteeLocalState",
          initialValue: '""',
          examples: []
        }
      },
      modules: [
        {
          id: "+OseJKfo3DTT4N7ChWmdHuhS+t8=",
          name: "General",
          description: "",
          operations: [
            {
              id: "lt7rMcfrl7bS7TdMVqa17mMDl+Q=",
              name: "initGrantee",
              description: "",
              schema: `input InitGranteeInput {
    granteeName: String!
	authorizedSignerAddress: String!
	grantSize: Float!
	matchingGrantSize: Float!
	grantSummary: String
	fundingAddress: String!
	fundingType: [FundingType!]!
	disbursementContractAddress: String!
	metricsDashboardLink: String
	startDate: DateTime!
	phaseDuration: Int 
	numberOfPhases: Int
}

# add new types here
scalar DateTime

enum FundingType {
	EOA
	Multisig
	TwoofThreeMultisig
	ThreeofFiveMultisig
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "mHTmz6XGHGWJHWxXy3Hii3jGDfw=",
              name: "editGrantee",
              description: "",
              schema: `input EditGranteeInput {
    granteeName: String
	authorizedSignerAddress: String
	grantSize: Float
	matchingGrantSize: Float
	grantSummary: String
	fundingAddress: String
	fundingType: [FundingType!]
	disbursementContractAddress: String
	metricsDashboardLink: String
}

# add new types here

enum FundingType {
	EOA
	Multisig
	TwoofThreeMultisig
	ThreeofFiveMultisig
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            }
          ]
        },
        {
          id: "3A4kkF6OxOHyGGgncwM6djzN8hs=",
          name: "Metrics",
          description: "",
          operations: [
            {
              id: "QxUDrkdO+EokzuWG4TBmbgfpMwE=",
              name: "editPhase",
              description: "",
              schema: `input EditPhaseInput {
    phaseIndex: Int!
	actuals: GranteeActuals
	planned: GranteePlanned
	stats: GranteeStats
	status: Status
}

# add new types here
enum Status {
	Uninitialized
	NotStarted
	InProgress
	Finalized
}

type GranteeActuals {
	arbReceived: Float
	arbUtilized: Float
	arbRemaining: Float
	contractsIncentivized: [Contract]
	incentives: String
	summary: String
	disclosures: String
}

type GranteePlanned {
	arbToBeDistributed: Float
	contractsIncentivized: [Contract]
	distributionMechanism: [DistributionMechanism]
	changes: String
  	expectations: String
}

type GranteeStats {
	avgDailyTVL: Float
  avgDailyTXNS: Float
  avgDailyUniqueUsers: Float
  kpis: [NamedKpi]
  changes: String
  lessons: String
}

type NamedKpi {
  name: String
  value: Float
}

type Contract {
  contractId: ID!
  contractLabel: String
  contractAddress: String
}

enum DistributionMechanism {
	LPIncentives
	Airdrop
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            }
          ]
        },
        {
          id: "SP6Fw+p8QrAs4gOLV7cHDB8zxKs=",
          name: "Admin",
          description: "",
          operations: [
            {
              id: "cKO7tnzqpRoSVGxEb+sghj1NwCc=",
              name: "addEditor",
              description: "",
              schema: `input AddEditorInput {
    editorAddress: String!
}

# add new types here
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "u8tIvljGJXe3bot26xghuLcdWkM=",
              name: "removeEditor",
              description: "",
              schema: `input RemoveEditorInput {
    editorAddress: String!
}

# add new types here
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            }
          ]
        },
        {
          id: "w/G/JrpyTW8dftQ4FA80Kyo4V24=",
          name: "Meta",
          description: "",
          operations: [
            {
              id: "FpNmPWTA5pgdFJcJRGektz+DmzE=",
              name: "addMeta",
              description: "",
              schema: `input AddMetaInput {
    protocolVersion: String!
    isAdmin: Boolean
    value: String
}

# add new types here
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "Ta6rZ37znhXxt1gD5wAOAIqy+RQ=",
              name: "updateMeta",
              description: "",
              schema: `input UpdateMetaInput {
    index: Float
    protocolVersion: String!
    isAdmin: Boolean
    value: String
}

# add new types here
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "h9YzEgDVqw/kFpTnqWqjiZm049w=",
              name: "deleteMeta",
              description: "",
              schema: `input DeleteMetaInput {
    index: Float
}

# add new types here
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            }
          ]
        }
      ]
    }
  ]
}, ie = (e) => e != null, xe = t.any().refine((e) => ie(e)), ae = t.enum(["Airdrop", "LPIncentives"]), O = t.enum(["EOA", "Multisig", "ThreeofFiveMultisig", "TwoofThreeMultisig"]), L = t.enum(["Finalized", "InProgress", "NotStarted", "Uninitialized"]);
function U() {
  return t.object({
    editorAddress: t.string()
  });
}
function k() {
  return t.object({
    isAdmin: t.boolean().nullish(),
    protocolVersion: t.string(),
    value: t.string().nullish()
  });
}
function Fe() {
  return t.object({
    __typename: t.literal("ArbitrumLtipGranteeLocalState").optional()
  });
}
function Oe() {
  return t.object({
    __typename: t.literal("ArbitrumLtipGranteeState").optional(),
    authorizedSignerAddress: t.string().nullable(),
    disbursementContractAddress: t.string().nullable(),
    editorAddresses: t.array(t.string().nullable()).nullable(),
    fundingAddress: t.string().nullable(),
    fundingType: t.array(O.nullable()).nullable(),
    grantSize: t.number().nullable(),
    grantSummary: t.string().nullable(),
    granteeName: t.string().nullable(),
    id: t.string(),
    matchingGrantSize: t.number().nullable(),
    meta: t.array(se().nullable()).nullable(),
    metricsDashboardLink: t.string().nullable(),
    phases: t.array(de().nullable()).nullable()
  });
}
function R() {
  return t.object({
    __typename: t.literal("Contract").optional(),
    contractAddress: t.string().nullable(),
    contractId: t.string(),
    contractLabel: t.string().nullable()
  });
}
function j() {
  return t.object({
    index: t.number().nullish()
  });
}
function q() {
  return t.object({
    authorizedSignerAddress: t.string().nullish(),
    disbursementContractAddress: t.string().nullish(),
    fundingAddress: t.string().nullish(),
    fundingType: t.array(O).nullish(),
    grantSize: t.number().nullish(),
    grantSummary: t.string().nullish(),
    granteeName: t.string().nullish(),
    matchingGrantSize: t.number().nullish(),
    metricsDashboardLink: t.string().nullish()
  });
}
function B() {
  return t.object({
    actuals: $().nullish(),
    phaseIndex: t.number(),
    planned: H().nullish(),
    stats: K().nullish(),
    status: L.nullish()
  });
}
function $() {
  return t.object({
    __typename: t.literal("GranteeActuals").optional(),
    arbReceived: t.number().nullable(),
    arbRemaining: t.number().nullable(),
    arbUtilized: t.number().nullable(),
    contractsIncentivized: t.array(R().nullable()).nullable(),
    disclosures: t.string().nullable(),
    incentives: t.string().nullable(),
    summary: t.string().nullable()
  });
}
function H() {
  return t.object({
    __typename: t.literal("GranteePlanned").optional(),
    arbToBeDistributed: t.number().nullable(),
    changes: t.string().nullable(),
    contractsIncentivized: t.array(R().nullable()).nullable(),
    distributionMechanism: t.array(ae.nullable()).nullable(),
    expectations: t.string().nullable()
  });
}
function K() {
  return t.object({
    __typename: t.literal("GranteeStats").optional(),
    avgDailyTVL: t.number().nullable(),
    avgDailyTXNS: t.number().nullable(),
    avgDailyUniqueUsers: t.number().nullable(),
    changes: t.string().nullable(),
    kpis: t.array(oe().nullable()).nullable(),
    lessons: t.string().nullable()
  });
}
function X() {
  return t.object({
    authorizedSignerAddress: t.string(),
    disbursementContractAddress: t.string(),
    fundingAddress: t.string(),
    fundingType: t.array(O),
    grantSize: t.number(),
    grantSummary: t.string().nullish(),
    granteeName: t.string(),
    matchingGrantSize: t.number(),
    metricsDashboardLink: t.string().nullish(),
    numberOfPhases: t.number().nullish(),
    phaseDuration: t.number().nullish(),
    startDate: t.string().datetime()
  });
}
function se() {
  return t.object({
    __typename: t.literal("Meta").optional(),
    isAdmin: t.boolean().nullable(),
    protocolVersion: t.string(),
    value: t.string().nullable()
  });
}
function oe() {
  return t.object({
    __typename: t.literal("NamedKpi").optional(),
    name: t.string().nullable(),
    value: t.number().nullable()
  });
}
function de() {
  return t.object({
    __typename: t.literal("Phase").optional(),
    actuals: $().nullable(),
    endDate: t.string().datetime(),
    planned: H().nullable(),
    startDate: t.string().datetime(),
    stats: K().nullable(),
    status: L.nullable()
  });
}
function W() {
  return t.object({
    editorAddress: t.string()
  });
}
function J() {
  return t.object({
    index: t.number().nullish(),
    isAdmin: t.boolean().nullish(),
    protocolVersion: t.string(),
    value: t.string().nullish()
  });
}
const mn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddEditorInputSchema: U,
  AddMetaInputSchema: k,
  ArbitrumLtipGranteeLocalStateSchema: Fe,
  ArbitrumLtipGranteeStateSchema: Oe,
  ContractSchema: R,
  DeleteMetaInputSchema: j,
  DistributionMechanismSchema: ae,
  EditGranteeInputSchema: q,
  EditPhaseInputSchema: B,
  FundingTypeSchema: O,
  GranteeActualsSchema: $,
  GranteePlannedSchema: H,
  GranteeStatsSchema: K,
  InitGranteeInputSchema: X,
  MetaSchema: se,
  NamedKpiSchema: oe,
  PhaseSchema: de,
  RemoveEditorInputSchema: W,
  StatusSchema: L,
  UpdateMetaInputSchema: J,
  definedNonNullAnySchema: xe,
  isDefinedNonNullAny: ie
}, Symbol.toStringTag, { value: "Module" })), Pe = (e) => e !== null && e > 0, S = (e) => e !== null && e >= 0, Ve = (e) => e.getTime() > Date.now();
function le(e) {
  return !!e && e.filter((n) => !!n).length > 0;
}
const z = (e) => !!e && e.length > 0, Ne = /^0x[a-fA-F0-9]{40}$/, ue = (e) => !!e && Ne.test(e), _e = (e) => {
  const n = w(e);
  return n.length > 0 && n.every(ue);
}, Ce = (e) => S(e.arbToBeDistributed) && le(e.distributionMechanism) && z(e.expectations) && z(e.changes), Le = (e) => S(e.arbReceived) && S(e.arbUtilized) && z(e.disclosures) && z(e.summary), Ue = (e) => S(e.avgDailyTVL) && S(e.avgDailyTXNS) && S(e.avgDailyUniqueUsers), l = {
  gtZero: Pe,
  gteZero: S,
  isValidAddress: ue,
  isValidAddressList: _e,
  isNotEmpty: le,
  isNotEmptyString: z,
  futureDate: Ve,
  isPlannedValid: Ce,
  isActualsValid: Le,
  isStatsValid: Ue
};
function ke(e) {
  return e ? e.slice(0, 7).map((n) => n) || [] : [];
}
function pn(e) {
  return e ? e.filter((n) => n !== null) : [];
}
function gn(...e) {
  return e.filter(Boolean).join(" ");
}
function _(e) {
  return (e == null ? void 0 : e.map((n) => n)) || [];
}
const ee = (e, n) => {
  let r = e + "";
  for (; r.length < n; )
    r = "0" + r;
  return r;
}, hn = (e) => {
  const n = new Date(e).toLocaleDateString("en-US").split("/");
  return `${ee(n[0], 2)} / ${ee(n[1], 2)}`;
}, bn = (e) => {
  const n = e[0], r = e[e.length - 1];
  let i = /* @__PURE__ */ new Date();
  i < new Date(n.startDate) && (i = new Date(n.startDate));
  const s = new Date(r.endDate).getTime() - i.getTime();
  return Math.max(0, Math.ceil(s / (1e3 * 60 * 60 * 24)));
}, fn = (e) => {
  var r;
  let n = 0;
  for (const i of e)
    n += ((r = i.actuals) == null ? void 0 : r.arbReceived) || 0;
  return n;
}, Sn = (e) => {
  var r;
  let n = 0;
  for (const i of e)
    n += ((r = i.actuals) == null ? void 0 : r.arbUtilized) || 0;
  return n;
}, An = (e) => {
  const n = /* @__PURE__ */ new Date();
  for (const r of e) {
    const i = new Date(r.startDate) < n, a = new Date(r.endDate) < n, s = i && !a;
    if (!i)
      break;
    const o = !!r.planned && l.isPlannedValid(r.planned), d = !!r.actuals && l.isActualsValid(r.actuals), g = !!r.stats && l.isStatsValid(r.stats);
    if (s && !o || a && (!o || !d || !g))
      return "Overdue";
  }
  return "On Track";
}, Dn = (e) => (n) => {
  if (n.target.value === "") {
    e(0);
    return;
  }
  n.target.value = n.target.value.replace(/\D/g, "");
  const r = parseInt(n.target.value, 10);
  isNaN(r) || e(r);
}, yn = (e) => `${(e * 100).toFixed(2)}%`, ce = "0x50379DDB64b77e990Bc4A433c9337618C70D2C2a", Re = (e = ce) => ({
  signer: {
    user: {
      address: e,
      chainId: 1,
      networkId: ""
    },
    app: {
      key: "",
      name: ""
    },
    signatures: []
  }
}), Z = (e, n) => {
  if (!n)
    return !1;
  for (const r of _(e.editorAddresses))
    if (r === n)
      return !0;
  return e.authorizedSignerAddress === n;
}, I = (e, n) => n ? e.authorizedSignerAddress === n : !1, je = (e) => {
  const n = e.operations.global[e.operations.global.length - 1];
  expect(n.error).toBeUndefined();
}, qe = (e, n) => {
  const r = e.operations.global[e.operations.global.length - 1];
  expect(r.error).toBe(n);
}, w = (e) => (e || "").split(",").map((n) => n.trim()), C = (e) => (e || []).join(", "), Be = (e, n) => e.some((r) => r.contractAddress === n), ne = (e, n) => n.map((r) => r).filter((r) => !Be(e, r.contractAddress)).forEach((r) => e.push(r)), $e = (e) => {
  var r, i;
  const n = [];
  n.push({
    contractAddress: e.fundingAddress,
    contractId: "Funding Address",
    contractLabel: "Funding Address"
  });
  for (const a of ke(e.phases))
    ne(n, ((r = a.planned) == null ? void 0 : r.contractsIncentivized) || []), ne(n, ((i = a.actuals) == null ? void 0 : i.contractsIncentivized) || []);
  return n;
}, He = (e) => (e == null ? void 0 : e.summary) === "", Ke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createContext: Re,
  expectException: qe,
  expectNoException: je,
  findAllContracts: $e,
  fromCommaDelimitedString: w,
  isActualsEmpty: He,
  isAdminRole: I,
  isEditorRole: Z,
  signer: ce,
  toCommaDelimitedString: C
}, Symbol.toStringTag, { value: "Module" })), Xe = (e) => [
  "Across Protocol",
  "Clipper",
  "Copra",
  "DODO",
  "Verified USD",
  "Pear Protocol",
  "Synthetix"
].includes(e) ? Date.UTC(2024, 5, 2, 23) : ["Peapods Finance"].includes(e) ? Date.UTC(2024, 5, 2, 22) : Date.UTC(2024, 5, 3, 7), te = {
  initGranteeOperation(e, n, r) {
    if (e.authorizedSignerAddress !== null && e.authorizedSignerAddress !== void 0 && l.isValidAddress(e.authorizedSignerAddress))
      throw new Error("Grantee already initialized");
    const {
      authorizedSignerAddress: i,
      disbursementContractAddress: a,
      fundingAddress: s,
      fundingType: o,
      grantSize: d,
      matchingGrantSize: g,
      grantSummary: m,
      granteeName: u,
      metricsDashboardLink: h,
      startDate: f,
      numberOfPhases: T,
      phaseDuration: A
    } = n.input;
    if (!l.isValidAddress(i))
      throw new Error("authorizedSignerAddress is invalid");
    if (!l.gtZero(d))
      throw new Error("grantSize must be greater than 0");
    if (!l.isNotEmptyString(u))
      throw new Error("granteeName is required");
    const D = w(
      a
    );
    if (D.length < 1)
      throw new Error("disbursementContractAddress is required");
    if (D.some((b) => !l.isValidAddress(b)))
      throw new Error(
        "disbursementContractAddress is improperly formatted"
      );
    const y = w(s);
    if (y.length < 1)
      throw new Error("fundingAddress is required");
    if (y.some((b) => !l.isValidAddress(b)))
      throw new Error("fundingAddress is improperly formatted");
    if (e.authorizedSignerAddress = i, e.disbursementContractAddress = C(
      D
    ), e.fundingAddress = C(y), e.fundingType = o, e.grantSize = d, e.matchingGrantSize = g, e.granteeName = u, m && (e.grantSummary = m), h && (e.metricsDashboardLink = h), !T)
      throw new Error("numberOfPhases is required");
    if (!A)
      throw new Error("phaseDuration is required");
    if (T <= 0 || T > 10)
      throw new Error("numberOfPhases must be in [0, 10]");
    if (A < 1 || A > 31)
      throw new Error("phaseDuration must be in than [1, 31]");
    const p = Xe(u), E = [];
    for (let b = 0; b < T; b++) {
      const P = new Date(p);
      P.setUTCDate(
        P.getUTCDate() + b * A
      );
      const V = new Date(p);
      V.setUTCDate(
        V.getUTCDate() + (b + 1) * A
      );
      const Ee = P.toISOString(), we = V.toISOString(), Te = {
        startDate: Ee,
        endDate: we,
        status: "NotStarted",
        actuals: {
          arbReceived: 0,
          arbRemaining: 0,
          arbUtilized: 0,
          contractsIncentivized: [],
          incentives: "",
          disclosures: "",
          summary: ""
        },
        planned: {
          arbToBeDistributed: 0,
          contractsIncentivized: [],
          distributionMechanism: [],
          changes: "",
          expectations: ""
        },
        stats: {
          avgDailyTVL: 0,
          avgDailyTXNS: 0,
          avgDailyUniqueUsers: 0,
          changes: "",
          lessons: "",
          kpis: []
        }
      };
      E.push(Te);
    }
    e.phases = E;
  },
  editGranteeOperation(e, n, r) {
    var D, y;
    const i = (y = (D = n.context) == null ? void 0 : D.signer) == null ? void 0 : y.user.address;
    if (!i)
      throw new Error("Unauthorized signer");
    const {
      // editor or admin
      fundingAddress: a,
      fundingType: s,
      granteeName: o,
      grantSummary: d,
      metricsDashboardLink: g,
      matchingGrantSize: m,
      // admin only
      grantSize: u,
      authorizedSignerAddress: h,
      disbursementContractAddress: f
    } = n.input;
    if (!Z(e, i))
      throw new Error("Unauthorized signer");
    {
      if (a) {
        const p = w(a);
        if (p.length < 1)
          throw new Error("fundingAddress is required");
        if (p.some(
          (E) => !l.isValidAddress(E)
        ))
          throw new Error("fundingAddress is improperly formatted");
        e.fundingAddress = a;
      }
      s && (e.fundingType = s), o && (e.granteeName = o), d && (e.grantSummary = d), m != null && m !== void 0 && (e.matchingGrantSize = m), g && (e.metricsDashboardLink = g);
    }
    if (I(e, i)) {
      if (u != null && u !== void 0) {
        if (!l.gtZero(u))
          throw new Error("grantSize must be greater than 0");
        e.grantSize = u;
      }
      if (h) {
        if (!l.isValidAddress(h))
          throw new Error("authorizedSignerAddress is invalid");
        e.editorAddresses || (e.editorAddresses = []), e.editorAddresses.push(i);
        const p = e.editorAddresses.indexOf(
          h
        );
        p !== -1 && e.editorAddresses.splice(p, 1), e.authorizedSignerAddress = h;
      }
      if (f) {
        const p = w(
          f
        );
        if (p.length < 1)
          throw new Error("disbursementContractAddress is required");
        if (p.some(
          (E) => !l.isValidAddress(E)
        ))
          throw new Error(
            "disbursementContractAddress is improperly formatted"
          );
        e.disbursementContractAddress = f;
      }
    }
  }
}, We = {
  editPhaseOperation(e, n, r) {
    var h, f;
    const i = (f = (h = n.context) == null ? void 0 : h.signer) == null ? void 0 : f.user.address;
    if (!Z(e, i))
      throw new Error("Unauthorized signer");
    const { status: a, actuals: s, planned: o, stats: d, phaseIndex: g } = n.input, { phases: m } = e;
    if (!m || m.length === 0)
      throw new Error("state phases are uninitialized");
    if (g < 0 || g >= m.length)
      throw new Error("phaseIndex is invalid");
    const u = m[g];
    if (!u)
      throw new Error("phase is not found");
    if (a && (u.status = a), s && (u.actuals = s), o)
      if (l.isPlannedValid(o))
        u.planned = o;
      else
        throw new Error("planned is not valid");
    d && (u.stats = d);
  }
}, re = {
  addEditorOperation(e, n, r) {
    var o, d;
    const i = (d = (o = n.context) == null ? void 0 : o.signer) == null ? void 0 : d.user.address;
    if (!I(e, i))
      throw new Error("Unauthorized signer");
    const { editorAddress: a } = n.input;
    if (!l.isValidAddress(a))
      throw new Error("Invalid address");
    const s = new Set(e.editorAddresses);
    s.add(a), e.editorAddresses = Array.from(s);
  },
  removeEditorOperation(e, n, r) {
    var o, d;
    const i = (d = (o = n.context) == null ? void 0 : o.signer) == null ? void 0 : d.user.address;
    if (!I(e, i))
      throw new Error("Unauthorized signer");
    const { editorAddress: a } = n.input;
    if (!l.isValidAddress(a))
      throw new Error("Invalid address");
    const s = new Set(e.editorAddresses);
    s.delete(a), e.editorAddresses = Array.from(s);
  }
}, N = {
  addMetaOperation(e, n, r) {
    if (!n.input.protocolVersion)
      throw new Error("protocolVersion is required");
    if (!n.input.value)
      throw new Error("value is required");
    e.meta || (e.meta = []), e.meta.push({
      protocolVersion: n.input.protocolVersion,
      isAdmin: n.input.isAdmin === !0,
      value: n.input.value
    });
  },
  updateMetaOperation(e, n, r) {
    if (!e.meta || e.meta.length === 0)
      throw new Error("no meta to update");
    const i = n.input.index || 0;
    if (i < 0 || i >= e.meta.length)
      throw new Error("invalid index");
    const a = _(e.meta)[i];
    if (a.isAdmin)
      throw new Error("unauthorized");
    n.input.protocolVersion && (a.protocolVersion = n.input.protocolVersion), n.input.value && (a.value = n.input.value), n.input.isAdmin && (a.isAdmin = n.input.isAdmin);
  },
  deleteMetaOperation(e, n, r) {
    if (!e.meta || e.meta.length === 0)
      throw new Error("no meta to delete");
    const i = n.input.index || 0;
    if (i < 0 || i >= e.meta.length)
      throw new Error("invalid index");
    if (_(e.meta)[i].isAdmin)
      throw new Error("unauthorized");
    e.meta.splice(i, 1);
  }
}, Je = (e, n, r) => {
  if (c.isBaseAction(n))
    return e;
  switch (n.type) {
    case "INIT_GRANTEE":
      X().parse(n.input), te.initGranteeOperation(e[n.scope], n, r);
      break;
    case "EDIT_GRANTEE":
      q().parse(n.input), te.editGranteeOperation(e[n.scope], n, r);
      break;
    case "EDIT_PHASE":
      B().parse(n.input), We.editPhaseOperation(e[n.scope], n, r);
      break;
    case "ADD_EDITOR":
      U().parse(n.input), re.addEditorOperation(e[n.scope], n, r);
      break;
    case "REMOVE_EDITOR":
      W().parse(n.input), re.removeEditorOperation(e[n.scope], n, r);
      break;
    case "ADD_META":
      k().parse(n.input), N.addMetaOperation(e[n.scope], n, r);
      break;
    case "UPDATE_META":
      J().parse(n.input), N.updateMetaOperation(e[n.scope], n, r);
      break;
    case "DELETE_META":
      j().parse(n.input), N.deleteMetaOperation(e[n.scope], n, r);
      break;
    default:
      return e;
  }
}, M = c.createReducer(Je), Ze = { id: "", granteeName: "", authorizedSignerAddress: "", editorAddresses: [], grantSize: 0, matchingGrantSize: 0, grantSummary: "", fundingAddress: "", fundingType: [], disbursementContractAddress: "", metricsDashboardLink: "", phases: [], meta: [] }, Qe = {}, v = {
  fileExtension: "grantee",
  createState(e) {
    return { global: { ...Ze, ...e == null ? void 0 : e.global }, local: { ...Qe, ...e == null ? void 0 : e.local } };
  },
  createExtendedState(e) {
    return c.createExtendedState(
      { ...e, documentType: "arbitrum/ltip-grantee" },
      v.createState
    );
  },
  createDocument(e) {
    return c.createDocument(
      v.createExtendedState(e),
      v.createState
    );
  },
  saveToFile(e, n, r) {
    return c.saveToFile(e, n, "grantee", r);
  },
  saveToFileHandle(e, n) {
    return c.saveToFileHandle(e, n);
  },
  loadFromFile(e) {
    return c.loadFromFile(e, M);
  },
  loadFromInput(e) {
    return c.loadFromInput(e, M);
  }
}, { createAction: me } = c, pe = (e) => me(
  "INIT_GRANTEE",
  { ...e },
  void 0,
  X,
  "global"
), ge = (e) => me(
  "EDIT_GRANTEE",
  { ...e },
  void 0,
  q,
  "global"
);
class Ye extends G {
  initGrantee(n) {
    return this.dispatch(pe(n));
  }
  editGrantee(n) {
    return this.dispatch(ge(n));
  }
}
const { createAction: en } = c, he = (e) => en(
  "EDIT_PHASE",
  { ...e },
  void 0,
  B,
  "global"
);
class nn extends G {
  editPhase(n) {
    return this.dispatch(he(n));
  }
}
const { createAction: be } = c, fe = (e) => be(
  "ADD_EDITOR",
  { ...e },
  void 0,
  U,
  "global"
), Se = (e) => be(
  "REMOVE_EDITOR",
  { ...e },
  void 0,
  W,
  "global"
);
class tn extends G {
  addEditor(n) {
    return this.dispatch(fe(n));
  }
  removeEditor(n) {
    return this.dispatch(Se(n));
  }
}
const { createAction: Q } = c, Ae = (e) => Q(
  "ADD_META",
  { ...e },
  void 0,
  k,
  "global"
), De = (e) => Q(
  "UPDATE_META",
  { ...e },
  void 0,
  J,
  "global"
), ye = (e) => Q(
  "DELETE_META",
  { ...e },
  void 0,
  j,
  "global"
);
class rn extends G {
  addMeta(n) {
    return this.dispatch(Ae(n));
  }
  updateMeta(n) {
    return this.dispatch(De(n));
  }
  deleteMeta(n) {
    return this.dispatch(ye(n));
  }
}
const F = class F extends G {
  constructor(n, r) {
    super(M, v.createDocument(n), r);
  }
  saveToFile(n, r) {
    return super.saveToFile(n, F.fileExtension, r);
  }
  loadFromFile(n) {
    return super.loadFromFile(n);
  }
  static async fromFile(n) {
    const r = new this();
    return await r.loadFromFile(n), r;
  }
};
Y(F, "fileExtension", "grantee");
let x = F;
Ge(x, [
  Ye,
  nn,
  tn,
  rn
]);
const an = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addEditor: fe,
  addMeta: Ae,
  deleteMeta: ye,
  editGrantee: ge,
  editPhase: he,
  initGrantee: pe,
  removeEditor: Se,
  updateMeta: De
}, Symbol.toStringTag, { value: "Module" })), sn = x, on = { ...v, ...Ke }, dn = { ...Ie, ...an }, En = {
  Document: sn,
  reducer: M,
  actions: dn,
  utils: on,
  documentModel: Me
};
export {
  x as A,
  Re as B,
  Z as C,
  sn as D,
  I as E,
  je as F,
  qe as G,
  gn as a,
  C as b,
  ke as c,
  dn as d,
  $e as e,
  w as f,
  He as g,
  he as h,
  Dn as i,
  fn as j,
  Sn as k,
  bn as l,
  pn as m,
  An as n,
  yn as o,
  hn as p,
  fe as q,
  Se as r,
  En as s,
  _ as t,
  M as u,
  l as v,
  on as w,
  Me as x,
  ce as y,
  mn as z
};
